import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import {
  BasicNodeLayout,
  DocumentSchemaSource,
  NodeOperationIcon,
  NodeSize,
  NodeType,
  NodeTypeCategory
} from "../Base";
import { DataType, primitiveTypes } from "../TypeDefinitions";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";
import { listOfEmptyObjectSchemaId } from "../DataSchemas";

const listOutputName = "result";

const dataTypePropertyName = "dataType";
const schemaProperty = "schemaId";
const schemaNameProperty = "schemaName";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.listEmpty,
  category: NodeTypeCategory.lists,
  operationIcon: NodeOperationIcon.zero,
  featureToggle: "feat-core-2471-flows-list-add-empty-nodes",
  controlOutputs: [],
  dataInputs: [],
  dataOutputs: [
    { enabled: true, type: DataType.OBJECTLIST, name: listOutputName, schemaId: listOfEmptyObjectSchemaId }
  ],
  nodeConfigProperties: [
    {
      name: dataTypePropertyName,
      label: "Type",
      propertyType: NodeConfigPropertyType.DataType,
      clearPropertiesOnChange: [schemaProperty],
      options: {
        dataTypes: [DataType.OBJECT, DataType.OBJECTREFERENCE].concat(primitiveTypes),
        dataProperties: [listOutputName]
      },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaProperty,
      label: "Object",
      propertyType: NodeConfigPropertyType.Schema,
      showOnPropertyValues: { propertyName: dataTypePropertyName, propertyValues: [DataType.OBJECT, undefined] },
      options: {
        changeSchemaOnConnection: true,
        excludeReferences: true,
        displayProperty: schemaNameProperty,
        dataProperties: [listOutputName]
      },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaProperty,
      label: "Reference",
      propertyType: NodeConfigPropertyType.Schema,
      showOnPropertyValues: { propertyName: dataTypePropertyName, propertyValues: [DataType.OBJECTREFERENCE] },
      options: {
        changeSchemaOnConnection: true,
        referenceOnly: true,
        displayProperty: schemaNameProperty,
        dataProperties: [listOutputName]
      },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaNameProperty,
      propertyType: NodeConfigPropertyType.NoInput
    }
  ],
  size: NodeSize.Small,
  evaluate: () => {
    return {
      output: {},
      activeControlHandleIds: []
    };
  }
});

export const ListEmptyNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  return <BasicNodeLayout id={id} data={data} />;
};
